import React from 'react'
import type { UserDto } from 'enrollment-platform/pages/AccessControl/api/access-control.client'
import RoleChips from 'enrollment-platform/pages/AccessControl/components/RoleChips/RoleChips'

interface Props {
  /** The admin's row from the batch lookup; absent until it resolves, or when the viewer may not read roles. */
  user?: UserDto
}

/**
 * A customer admin's RBAC roles as Permission Management shows them: granted
 * roles as chips, the implied role as the fallback when none are granted,
 * "None" otherwise. Nothing renders until the lookup has the admin's row, so
 * a viewer without Read on UserPermission sees the row as before.
 */
export default function AdminRoleChips({ user }: Props) {
  if (!user) return null
  const roles = user.roles ?? user.roleIds.map((id) => ({ id, name: id }))
  return (
    <RoleChips roles={roles} impliedRole={user.impliedRole} size="regular" />
  )
}
